import { GameLoaderDialogProperties } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/properties/GameLoaderDialogProperties";
import { GameLoaderFontStyle } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/style/GameFontStyle";
import { AbstractPreloaderProperties } from "@lib/titan2/dist/game/view/properties/AbstractPreloaderProperties";
import { Point } from "pixi.js";
/**
 * LoaderLandscapeProperties.ts
 */
export class LoaderLandscapeProperties extends GameLoaderDialogProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.backgroundProperties.position.set(983, 512); //shifting 10px to the rights
        this.backgroundProperties.scale.set(0.8);
        this.versionFieldProperties = this.versionFieldProperties.copyTo(GameLoaderFontStyle.VERSION_ALT);
        this.versionFieldProperties.position = new Point(1900, 964);
        this.versionFieldProperties.size = new Point(95, 40);
        this.playButtonProperties.position.set(665, 770);
        this.playButtonProperties.scale.set(0.62);
        this.playButtonProperties.textFieldProperties.size = new Point(900, 200);
        this.playButtonProperties.textFieldOffset.set(0, -15);
        this.progressBarBackgroundProperties.position.set(728, 792);
        this.progressBarProperties.position.set(21, 24);
        this.centerTextProperties.position.set(973, 575);
        this.centerTextProperties.size = new Point(565, 160);
        this.rightTextProperties.position.set(1738, 15);
        this.rightTextProperties.size = new Point(420, 500);
        this.rightTextProperties.visible = true;
        this.leftTextProperties.position.set(214, 380);
        this.leftTextProperties.size = new Point(350, 500);
        this.rightTextProperties.visible = true;
        this.infoFieldFooterProperties.position.set(973, 904);
        this.infoFieldFooterProperties.size = new Point(720, 80);
        this.copyrightProperties = this.copyrightProperties.copyTo(GameLoaderFontStyle.COPYRIGHT_ALT);
        this.copyrightProperties.position = new Point(973, 984);
        this.copyrightProperties.size = new Point(720, 40);
    }
}
/**
 * PreloaderLandscapeProperties.ts
 */
export class PreloaderLandscapeProperties extends AbstractPreloaderProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.spineProperties.position.set(973, 440);
        this.messageSpinePosition = new Point(875, 349);
        this.messageProperties.position = new Point(665, 550);
        this.messageProperties.size = new Point(940, 220);
        this.messageProperties.multiline = true;
    }
}
//# sourceMappingURL=LoaderLandscapeProperties.js.map